if (!customElements.get('cta-bar')) {
  class CtaBar extends HTMLElement {
    constructor() {
      super();
      this.threshold = 1.5 * window.innerHeight;
      this.bottomThreshold = 150;
      this.isShown = false;
      this.variantUnsubscribe = null;
      this.boundOnScroll = this.onScroll.bind(this);
      this.boundOnResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.setupVariantSubscription();
      this.threshold = 1.5 * window.innerHeight;
      window.addEventListener('scroll', this.boundOnScroll, { passive: true });
      window.addEventListener('resize', this.boundOnResize);
      this.onScroll();
    }

    disconnectedCallback() {
      if (this.variantUnsubscribe) {
        this.variantUnsubscribe();
      }
      window.removeEventListener('scroll', this.boundOnScroll);
      window.removeEventListener('resize', this.boundOnResize);
    }

    setupVariantSubscription() {
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event.data?.variant;
          if (!variant) return;

          const titleEl = this.querySelector('.cta-variant-title');
          if (titleEl) {
            titleEl.textContent = variant.title;
          }

          const priceEl = this.querySelector('.cta-variant-price');
          const newPriceEl = event.data?.html?.querySelector('.cta-variant-price')?.innerHTML;

          if (newPriceEl && priceEl) {
            priceEl.innerHTML = newPriceEl;
          } else if (priceEl) {
            if (window.Shopify && window.Shopify.formatMoney) {
              priceEl.innerHTML = Shopify.formatMoney(variant.price, window.theme?.currency?.format);
            } else {
              const priceFormatted = (variant.price / 100).toFixed(2);
              priceEl.textContent = `$${priceFormatted}`;
            }
          }

          const cartIdInputs = this.querySelectorAll('input[name="id"]');
          cartIdInputs.forEach((input) => {
            input.value = variant.id;
          });
        });
      }
    }

    show() {
      if (this.isShown) return;
      this.classList.remove('translate-y-full', 'opacity-0', 'pointer-events-none');
      this.classList.add('translate-y-0', 'opacity-100', 'pointer-events-auto');
      this.isShown = true;
    }

    hide() {
      if (!this.isShown) return;
      this.classList.add('translate-y-full', 'opacity-0', 'pointer-events-none');
      this.classList.remove('translate-y-0', 'opacity-100', 'pointer-events-auto');
      this.isShown = false;
    }

    onScroll() {
      const y = window.scrollY || document.documentElement.scrollTop;
      const scrollBottom = document.documentElement.scrollHeight - window.innerHeight - y;
      const discountWidget = document.querySelector('.needsclick[role="button"]');
      const chatWidget = document.querySelector('#gorgias-chat-container #chat-button');

      if (y >= this.threshold && scrollBottom >= this.bottomThreshold) {
        this.show();

        if (discountWidget?.style?.bottom) {
          discountWidget.style.bottom = '100px';
        }

        if (chatWidget?.style?.bottom) {
          chatWidget.style.bottom = '120px';
        }
      } else {
        this.hide();

        if (discountWidget?.style?.bottom) {
          discountWidget.style.bottom = '10px';
        }

        if (chatWidget?.style?.bottom) {
          chatWidget.style.bottom = '20px';
        }
      }
    }

    onResize() {
      this.threshold = 1.5 * window.innerHeight;
      this.onScroll();
    }
  }

  customElements.define('cta-bar', CtaBar);
}
